export { default as Stats } from "./Stats.svelte";
